import { Link } from "react-router-dom";
import { borrowChannels } from "../data/channels.js";
import { faviconUrl } from "../lib/cms.js";

export default function Borrow() {
  return (
    <>
      <section className="page-header">
        <div className="wrap">
          <div className="eyebrow">Borrow from us</div>
          <h1>Three ways to access credit from Daksfirst.</h1>
          <p className="sub">
            Bespoke direct credit, UK lending platforms, or our RBI-registered Indian NBFC.
            All applications run through the central borrower portal at{" "}
            <a href="https://apply.daksfirst.com" target="_blank" rel="noopener noreferrer" style={{ color: "var(--gold)", textDecoration: "underline" }}>
              apply.daksfirst.com
            </a>.
          </p>
        </div>
      </section>

      <section>
        <div className="wrap">
          <div className="channel-list">
            {borrowChannels.map((c, i) => (
              <article className="channel" key={i}>
                <div className="channel-head">
                  <div className="channel-num">0{i + 1}</div>
                  <div>
                    <div className="eyebrow">{c.eyebrow}</div>
                    <h2 className="channel-title">{c.title}</h2>
                  </div>
                </div>
                <p className="channel-body">{c.body}</p>

                {c.items && (
                  <div className="channel-items">
                    {c.items.map((it, j) => (
                      <div className="channel-item" key={j}>
                        <span className="ci-label">{it.label}</span>
                        <span className="ci-text">{it.text}</span>
                      </div>
                    ))}
                  </div>
                )}

                <div className="channel-cta">
                  {c.href.startsWith("/") ? (
                    <Link className="btn btn-primary" to={c.href}>{c.cta} →</Link>
                  ) : (
                    <a className="btn btn-primary" href={c.href} target={c.external ? "_blank" : undefined} rel="noopener noreferrer">{c.cta} ↗</a>
                  )}

                  {c.secondary && (
                    <Link className="btn btn-dark" to={c.secondary.href}>{c.secondary.label} →</Link>
                  )}

                  {c.extLinks && c.extLinks.length > 0 && (
                    <div className="ext-links">
                      <span className="ext-label">Also</span>
                      {c.extLinks.map((l, k) => (
                        <a
                          key={k}
                          href={l.href}
                          target="_blank"
                          rel="noopener noreferrer"
                          className={`ext-logo-tile ${l.logoBg === "dark" ? "ext-logo-tile-dark" : ""}`}
                          title={l.label}
                          aria-label={`Visit ${l.label}`}
                        >
                          <img src={l.logoSrc || faviconUrl(l.href)} alt={l.label} loading="lazy" />
                        </a>
                      ))}
                    </div>
                  )}
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="tight borrower-help">
        <div className="wrap">
          <div className="eyebrow">If something goes wrong</div>
          <div className="help-grid">
            <Link to="/complaints"><span className="t">Complaints</span><span className="s">How to complain, what we do and by when, and the Financial Ombudsman Service.</span></Link>
            <Link to="/financial-difficulty"><span className="t">Financial difficulty</span><span className="s">What we can do if your exit is delayed or a payment is missed.</span></Link>
            <Link to="/tariff"><span className="t">Tariff of charges</span><span className="s">Every fee type that may apply, confirmed in your DIP and facility letter.</span></Link>
            <Link to="/vulnerable-customers"><span className="t">Vulnerable customers</span><span className="s">How we adjust when circumstances make things harder.</span></Link>
          </div>
        </div>
      </section>

      <section className="reg tight">
        <div className="wrap" style={{ gridTemplateColumns: "1fr", textAlign: "center" }}>
          <div className="cell">
            <p className="muted" style={{ color: "var(--navy-70)", fontSize: 15, maxWidth: "60ch", margin: "0 auto" }}>
              All credit terms are agreed deal by deal. Indicative ranges only — please contact the team to discuss a specific transaction.
            </p>
            <a href="https://apply.daksfirst.com" target="_blank" rel="noopener noreferrer" className="btn btn-dark spacer-m">
              Open the borrower portal ↗
            </a>
          </div>
        </div>
      </section>
    </>
  );
}
